<template>
  <div class="flex justify-center items-center min-h-screen bg-page-bg">
    <div class="text-center">
      <!-- Spinner -->
      <div class="w-12 h-12 rounded-full border-b-2 animate-spin border-primary-400 mx-auto mb-4"></div>

      <!-- Loading Text -->
      <p v-if="text" class="text-text-secondary text-sm">
        {{ text }}
      </p>

      <!-- Default Text -->
      <p v-else class="text-text-secondary text-sm">
        {{ $t('common.loading') || 'Loading...' }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: ''
  }
})
</script>
